import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { useClientAccessToken } from "@/contexts/clientAccessTokenContext";
import { useExpireClientAccessTokenMutation } from "@/graphql/mutations/expireClientAccessToken.graphql.types";
import { CLIENT_ACCESS_TOKEN_COOKIE_KEY } from "@/types";
import { hasDjangoMutationError } from "@/utils/djangoMutationError";
import useErrorLogger from "@/utils/useErrorLogger";

export const useClientOTPLogout = () => {
  const { clientAccessToken, medspaSlug } = useClientAccessToken();

  const [expireToken] = useExpireClientAccessTokenMutation();

  const logError = useErrorLogger();

  const logoutUser = async () => {
    try {
      const { data } = await expireToken({
        variables: {
          clientAccessToken,
          medspaSlug,
        },
      });
      if (data?.expireClientAccessToken?.ok) {
        Cookies.remove(CLIENT_ACCESS_TOKEN_COOKIE_KEY);
        /**
         * Using this method instead of next/router.push to force a full page reload
         * so the provider/context can be re-initialized
         */
        window.location.href = `/client/${medspaSlug}/sign-in`;
      }
    } catch (error) {
      toast.error(
        hasDjangoMutationError(error) ? error.message : "Failed to logout user"
      );
      logError(error);
    }
  };

  return logoutUser;
};

export default useClientOTPLogout;
